namespace storage_ui {

   import NetworkSettingsItem = com.vmware.vsphere.client.h5.storage.data.adapters.NetworkSettingsItem;
   import InternetScsiStorageAdapterIpConfigurationUpdateSpec = storage_ui.InternetScsiStorageAdapterIpConfigurationUpdateSpec;
   import InternetScsiHba$IscsiIpv6Address = storage_ui.InternetScsiHba$IscsiIpv6Address;

   export class StorageAdapterEditNetworkSettingsDialogService {

      public static $inject = [
         "i18nService",
         "clarityModalService",
         "StorageAdapterNetworkSettingsConstants",
         "vxValidatorFactory",
         "mutationService",
         "hbaNetworkingUtil",
         "clarityConstants"
      ];
      private dialogData: any;

      constructor(private i18nService: any,
                  private clarityModalService: any,
                  private constants: any,
                  private vxValidatorFactory: any,
                  private mutationService: any,
                  private hbaNetworkingUtil: HbaNetworkingUtil,
                  private clarityConstants:any) {
      }

      open(hostId: any, adapter: any, networkSettings: NetworkSettingsItem): void {
         let spec = new InternetScsiStorageAdapterIpConfigurationUpdateSpec();
         spec.device = adapter.device;
         spec.properties = <InternetScsiHba$IPProperties>_.clone(networkSettings.properties);
         this.dialogData = {
            constants: this.constants,
            model: this.clone(networkSettings),
            validator: this.vxValidatorFactory.create(),
            spec: spec,
            ipv4StackBlockExpanded: true,
            ipv6StackBlockExpanded: false,
            dnsStackBlockExpanded: false,
            i18n: this.i18nService.getString,
            ipv6options: [{
               name: this.i18nService.getString("Common", "enabled"),
               value: true
            }, {
               name: this.i18nService.getString("Common", "disabled"),
               value: false
            }],
            ipv6LinkLocalAddress: null
         };

         let modalOptions = {
            title: this.i18nService.getString("StorageUi", "storage.adapters.properties.ipDnsConfig.edit.h5header"),
            subTitle: {
               text: adapter.device
            },
            defaultButton: "submit",
            size: "lg",
            alerts: <any[]>[],
            dialogData: this.dialogData,
            contentTemplate: "storage-ui/resources/storage/views/host/adapters/network/StorageAdapterEditNetworkSettingsDialog.html",
            onSubmit: ()=> {
               let errors = this.dialogData.validator.validate();
               if (errors.length) {
                  modalOptions.alerts = _.map(errors, (error)=>({
                     text: error,
                     type: this.clarityConstants.notifications.type.ERROR
                  }));
                  return false;
               }
               let isIpv6Dirty = this.updateIpv6PageData();
               if (this.updateDnsPageData() || this.updateIpv4PageData() || isIpv6Dirty) {
                  let spec = this.dialogData.spec;
                  if (!isIpv6Dirty) {
                     spec.properties.ipv6properties = null;
                  }
                  this.mutationService.apply(hostId, spec._type, spec);
               }
               return true;
            }
         };
         this.clarityModalService.openOkCancelModal(modalOptions);
      }

      /****
       * Returns a ~deep clone of passed networkSettingsItem,
       * Used to not change/store local version of Network Settings,
       * while update is still running
       *
       * @param networkSettings instance you wish to clone
       */
      private clone(networkSettings: NetworkSettingsItem): NetworkSettingsItem {
         let clone = _.clone(networkSettings);
         clone.properties = _.clone(networkSettings.properties);
         clone.properties.ipv6properties = _.clone(networkSettings.properties.ipv6properties);
         return clone;
      }

      private updateIpv4PageData(): boolean {
         let isDirty = false;
         let model = this.dialogData.model;
         let properties: InternetScsiHba$IPProperties = model.properties;
         let capabilities = model.capabilities;
         let spec: InternetScsiHba$IPProperties = this.dialogData.spec.properties;

         if (!capabilities.ipv4EnableSettable && !properties.ipv4Enabled) {
            // The IPv4 is not enabled and cannot be enabled.
            return false;
         }
         if (!capabilities.ipConfigurationMethodSettable && properties.dhcpConfigurationEnabled) {
            // The IPv4 DHCP is enabled and cannot be disabled.
            return false;
         }

         // Enable or disable the IPV4 configuration
         isDirty = isDirty || spec.ipv4Enabled !== properties.ipv4Enabled;
         spec.ipv4Enabled = properties.ipv4Enabled;

         if (properties.ipv4Enabled) {
            // Enable disable DHCP
            isDirty = isDirty || spec.dhcpConfigurationEnabled !== properties.dhcpConfigurationEnabled;
            spec.dhcpConfigurationEnabled = properties.dhcpConfigurationEnabled;

            if (!properties.dhcpConfigurationEnabled) {
               // Update the static ip configuration (when DHCP is false)
               isDirty = isDirty || spec.address !== properties.address
                     || spec.subnetMask !== properties.subnetMask
                     || spec.defaultGateway !== properties.defaultGateway;

               spec.address = properties.address;
               spec.subnetMask = properties.subnetMask;
               spec.defaultGateway = properties.defaultGateway;
            } else {
               spec.address = null;
               spec.subnetMask = null;
               spec.defaultGateway = null;
            }
         }

         return isDirty;
      }

      private updateIpv6PageData(): boolean {
         let isDirty = false;
         let spec = this.dialogData.spec.properties;
         let model = this.dialogData.model;
         let isOnlyLinkLocal = this.dialogData.selectedOption === this.constants.IPv6Settings.LINK_LOCAL;
         let properties = model.properties;
         let capabilities = model.capabilities;
         if (!capabilities.ipv6Supported) {
            return false;
         }
         if (!capabilities.ipv6EnableSettable && !properties.ipv6Enabled) {
            // The IPv6 is not enabled and cannot be enabled.
            return false;
         }
         //IPv6 has been disabled/enabled through UI
         if (capabilities.ipv6EnableSettable) {
            isDirty = spec.ipv6Enabled !== properties.ipv6Enabled;
            spec.ipv6Enabled = properties.ipv6Enabled;
            if (!spec.ipv6Enabled) {
               return isDirty;
            }
         }

         let linkLocalOverrideAddress: InternetScsiHba$IscsiIpv6Address|null = null;
         // Link-local override
         if (capabilities.ipv6LinkLocalAutoConfigurationSettable) {
            isDirty = isDirty || properties.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled !== spec.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled;
            spec.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled = properties.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled;
            let isLinkLocalOverrideDirty = this.dialogData.ipv6LinkLocalAddress !== this.hbaNetworkingUtil.getLinkLocalIPv6Address(spec);
            if (!spec.ipv6properties.ipv6LinkLocalAutoConfigurationEnabled && isLinkLocalOverrideDirty) {
               //if overriden - save address here
               linkLocalOverrideAddress = this.hbaNetworkingUtil.createIpv6(this.dialogData.ipv6LinkLocalAddress);
               spec.ipv6properties.iscsiIpv6Address.push(linkLocalOverrideAddress);
            }
         }

         //DHCP
         if (capabilities.ipv6DhcpConfigurationSettable) {
            isDirty = isDirty || spec.ipv6properties.ipv6DhcpConfigurationEnabled !== properties.ipv6properties.ipv6DhcpConfigurationEnabled;
            spec.ipv6properties.ipv6DhcpConfigurationEnabled = properties.ipv6properties.ipv6DhcpConfigurationEnabled;
            if (isDirty && spec.ipv6properties.ipv6DhcpConfigurationEnabled) {
               spec.ipv6properties.iscsiIpv6Address = [];
               spec.ipv6properties.ipv6DefaultGateway = null;
               spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled =
                     capabilities.ipv6RouterAdvertisementConfigurationSettable ? false : null;
               return isDirty;
            }
         } else {
            //If dhcp is not settable, setting it to ANY value (i.e. true a false) causes a backend exception
            spec.ipv6properties.ipv6DhcpConfigurationEnabled = null;
         }
         // Router advertisement
         if (capabilities.ipv6RouterAdvertisementConfigurationSettable) {
            isDirty = isDirty || spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled !== properties.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled;
            spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled = properties.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled;
            if (isDirty && spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled) {
               spec.ipv6properties.iscsiIpv6Address = [];
               spec.ipv6properties.ipv6DefaultGateway = null;
               return isDirty;
            }
         } else {
            spec.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled = null;
         }

         // Static addresses
         let automaticOptionSelected: boolean =
               properties.ipv6properties.ipv6DhcpConfigurationEnabled ||
               properties.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled;
         let origStaticAddresses: InternetScsiHba$IscsiIpv6Address[] =
               this.getIPv6StaticAddressesList(spec);

         if (!automaticOptionSelected) {
            let isStaticAddressDirty = this.isStaticIpv6Dirty(properties.ipv6properties.iscsiIpv6Address, origStaticAddresses);
            isDirty = isDirty || isStaticAddressDirty;
            if (isStaticAddressDirty || isOnlyLinkLocal) {
               spec.ipv6properties.iscsiIpv6Address = [];
               if (linkLocalOverrideAddress) {
                  spec.ipv6properties.iscsiIpv6Address.push(linkLocalOverrideAddress);
               }
               if (!isOnlyLinkLocal) {
                  spec.ipv6properties.iscsiIpv6Address = spec.ipv6properties.iscsiIpv6Address.concat(properties.ipv6properties.iscsiIpv6Address);
               }
               // mark old ones for removal

               _.each(origStaticAddresses, (address) => {
                  if (!_.find(properties.ipv6properties.iscsiIpv6Address, (newAddress:InternetScsiHba$IscsiIpv6Address)=>address.address===newAddress.address)) {
                     address.operation = this.constants.IPv6Settings.OPERATION.REMOVE;
                     spec.ipv6properties.iscsiIpv6Address.push(address);
                  }
               });

            }
         }

         // IPv6 Gateway
         if (capabilities.ipv6DefaultGatewaySettable) {
            let defaultGatewayIsDirty = spec.ipv6properties.ipv6DefaultGateway !== properties.ipv6properties.ipv6DefaultGateway;
            isDirty = isDirty || defaultGatewayIsDirty;
            if (!defaultGatewayIsDirty && isDirty) {
               spec.ipv6properties.ipv6DefaultGateway = null;
            } else {
               spec.ipv6properties.ipv6DefaultGateway = properties.ipv6properties.ipv6DefaultGateway;
            }
         }
         return isDirty;
      }

      private isStaticIpv6Dirty(current: InternetScsiHba$IscsiIpv6Address[],
                                old: InternetScsiHba$IscsiIpv6Address[]): boolean {
         //current array may have operations defined - we want to neglect them for this check
         current = _.pluck(_.sortBy(current, (address: InternetScsiHba$IscsiIpv6Address)=>address.address), "address");
         old = _.pluck(_.sortBy(old, (address: InternetScsiHba$IscsiIpv6Address)=>address.address), "address");
         return !_.isEqual(current, old);
      }

      private getIPv6StaticAddressesList(ipProperties: InternetScsiHba$IPProperties): InternetScsiHba$IscsiIpv6Address[] {
         let addressesList: InternetScsiHba$IscsiIpv6Address[] = [];
         if (!ipProperties || !ipProperties.ipv6properties || !ipProperties.ipv6properties.iscsiIpv6Address.length) {
            return addressesList;
         }
         // Add all static non link-local addresses.
         _.each(this.hbaNetworkingUtil.getIPv6AddressesOfType(ipProperties,
               this.constants.AddressConfigurationType.Static, true), (address: InternetScsiHba$IscsiIpv6Address) => {
            addressesList.push(address);
         });

         // Add all auto configured non link-local addresses, if routerAdv is enabled.
         if (ipProperties.ipv6properties.ipv6RouterAdvertisementConfigurationEnabled) {
            _.each(this.hbaNetworkingUtil.getIPv6AddressesOfType(ipProperties,
                  this.constants.AddressConfigurationType.AutoConfigured, true), (address: InternetScsiHba$IscsiIpv6Address) => {
               addressesList.push(address);
            });
         }

         // Add all dhcp non link-local addresses, if dhcp is enabled.
         if (ipProperties.ipv6properties.ipv6DhcpConfigurationEnabled) {
            _.each(this.hbaNetworkingUtil.getIPv6AddressesOfType(ipProperties,
                  this.constants.AddressConfigurationType.DHCP, true), (address: InternetScsiHba$IscsiIpv6Address) => {
               addressesList.push(address);
            });
         }

         return addressesList;
      }


      private updateDnsPageData(): boolean {
         let isDirty = false;
         let spec = this.dialogData.spec.properties;
         let model = this.dialogData.model.properties;
         let capabilities = this.dialogData.model.capabilities;
         if (capabilities.primaryDnsServerAddressSettable || capabilities.alternateDnsServerAddressSettable) {

            isDirty = (model.primaryDnsServerAddress !== spec.primaryDnsServerAddress
            || model.alternateDnsServerAddress !== spec.alternateDnsServerAddress);

            spec.primaryDnsServerAddress = model.primaryDnsServerAddress;
            spec.alternateDnsServerAddress = model.alternateDnsServerAddress;
         }
         return isDirty;
      }

   }

   angular
         .module("com.vmware.vsphere.client.storage")
         .service("storageAdapterEditNetworkSettingsDialogService", StorageAdapterEditNetworkSettingsDialogService);
}
